import { Pipe, PipeTransform, inject } from '@angular/core';
import { AdminCosmeticStatus } from '@web/shared/module/cosmetic';
import { Observable } from 'rxjs';
import { AdminCosmeticStatusProviderService } from '../providers/admin-cosmetic-status-provider.service';

@Pipe({
  name: 'adminCosmeticStatus',
})
export class AdminCosmeticStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminCosmeticStatusProviderService);

  public transform(status: AdminCosmeticStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
